export const ISSUES_FOR_COLOUR_REQUEST = "ISSUES_FOR_COLOUR_REQUEST";
export const ISSUES_FOR_COLOUR_SUCCESS = "ISSUES_FOR_COLOUR_SUCCESS";
export const ISSUES_FOR_COLOUR_FAILED = "ISSUES_FOR_COLOUR_FAILED";